import type { Tenant } from "@/api";

interface Props {
  id: string;
  tenants: Tenant[];
  value: string;
  onChange: (key: string) => void;
  /** Field label; "Client" is the user-facing name for a tenant. */
  label?: string;
}

/**
 * The client picker shared by the admin data pages.
 *
 * Pins on a single tenant: when exactly one tenant is visible (the common
 * tenant-admin case) it renders a fixed label instead of a pointless one-option
 * combobox; otherwise it renders a labelled `<select>`. This is the one place
 * the pin-on-single-tenant presentation lives — pages own data, this owns the
 * widget.
 */
export function TenantSelect({ id, tenants, value, onChange, label = "Client" }: Props) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="label">{label}</label>
      {tenants.length === 1 ? (
        <span className="px-1 py-1.5 font-medium">{tenants[0].name}</span>
      ) : (
        <select
          id={id}
          className="select min-w-44"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          {tenants.map((t) => (
            <option key={t.key} value={t.key}>{t.name}</option>
          ))}
        </select>
      )}
    </div>
  );
}
